// extracted by mini-css-extract-plugin
module.exports = {"container":"project_container__K8yH5","picture":"project_picture__1XOk9","description":"project_description__11i0b"};